var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "500"
    },
    on: {
      "input": _vm.closeConfirmModal
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v("Confirm delete")]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0 pt-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "accent--text",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeConfirmModal
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "error",
      "text": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" Удалить ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }